<template>
	<div>
		<div style="width: 1064px;margin: 5% auto;">
			<div id="img">
				<img style="width: 100%; height: 100%;" src="../../assets/background.jpg" />
			</div>
			<div style="float: left;padding: 64px;width: 365px;height: 700px;">
				<Card :dis-hover="true" style="width: 484px;height: 600px;">
					<Form ref="formValidate" :model="loginForm" :rules="ruleValidate">
						<p>movie</p>
						<div id="login">
              <FormItem style="margin-top: 30px;" prop="company">
                <Input placeholder="请输入影院名称" v-model="loginForm.company" style="width: auto" >
                  <Icon type="ios-contact" slot="prefix" class="icon" />
                </Input>
              </FormItem>
              <FormItem prop="nikeName">
                <Input placeholder="请输入联系人" v-model="loginForm.nikeName" style="width: auto">
                  <Icon type="ios-contact" slot="prefix" class="icon" />
                </Input>
              </FormItem>
              <FormItem prop="phone">
                <Input placeholder="请输入手机号" v-model="loginForm.phone" style="width: auto">
                  <Icon type="ios-contact" slot="prefix" class="icon" />
                </Input>
              </FormItem>
              <FormItem prop="address">
                <Input placeholder="请输入地址" v-model="loginForm.address" style="width: auto">
                  <Icon type="ios-contact" slot="prefix" class="icon" />
                </Input>
              </FormItem>
							<FormItem prop="userName">
								<Input placeholder="请输入账号" v-model="loginForm.userName" style="width: auto">
								<Icon type="ios-contact" slot="prefix" class="icon" />
								</Input>
							</FormItem>
							<FormItem style="margin-top: 30px;" prop="password">
								<Input placeholder="请输入密码" v-model="loginForm.password" style="width: auto" type="password">
								<Icon type="ios-lock-outline" slot="prefix" class="icon" />
								</Input>
							</FormItem>
							<Button type="info" style="width: 400px;margin-top: 13px" @click.native="onSubmit('formValidate');">注册</Button>
              <Button type="info" style="width: 150px;margin-top: 30px;margin-left: 65%;text-align: center;color: blue;" @click="login();">已有账号，去登录</Button>
						</div>
					</Form>
				</Card>
			</div>
		</div>
	</div>
</template>

<script>
	import {
    register
	} from '@/request/api'

	export default {
		data() {
			return {
				loginForm: {
          userName: '',
					password: '',
          company: '',
          address:'',
          phone:'',
          nikeName: '',
				},
				ruleValidate: {
					userName: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
          phone: [
            {
              required: true,
              message: '请输入正确的手机号',
              trigger: 'blur'
            }
          ],
          company: [{
            required: true,
            message: '请输入影院名称',
            trigger: 'blur'
          }],
          address: [{
            required: true,
            message: '请输入地址',
            trigger: 'blur'
          }],
          nikeName: [{
            required: true,
            message: '请输入联系人',
            trigger: 'blur'
          }],
				}
			}
		},
		methods: {
			onSubmit(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
            var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
            if(reg_tel.test(this.loginForm.phone)) {
              this.handleSpinCustomShow();
              let formData = this.loginForm
              register(formData).then((res) => {
                this.handleSpinCustomHide();
                if (res.code == 20000) {
                  this.$Message.error("注册成功，请去登录！");
                  this.$router.history.push('/login')
                } else {
                  this.$Message.error(res.msg);
                }
              })
            }else{
              this.$Message.error("请输入正确的手机号！");
            }
					} else {
						this.$Message.error('必填项有为空，请把为空的填上!');
					}
				})
			},
			handleSpinCustomShow() {
				this.$Spin.show({
					render: (h) => {
						return h('div', [
							h('Icon', {
								'class': 'demo-spin-icon-load',
								props: {
									type: 'ios-loading',
									size: 18
								}
							}),
							h('div', '注册中')
						])
					}
				});
			},
			handleSpinCustomHide() {
				this.$Spin.hide();
			},
      login(){
        this.$router.history.push('/login')
      }
		},
  }
</script>

<style>
	.demo-spin-icon-load {
		animation: ani-demo-spin 1s linear infinite;
	}
</style>

<style>
	p {
		height: 40px;
		font-size: 30px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		line-height: 30px;
		color: #333333;
		opacity: 1;
		margin-top: 44px;
		text-align: center;
	}

	#img {
		width: 550px;
		height: 538px;
		background: rgba(0, 0, 0, 0);
		opacity: 1;
		float: left;
		/* border: 1px solid #EEEEEE; */

	}

	#login {
		width: 400px;
		height: 130px;
		margin-top: 46px;
		margin-left: 22px;
		text-align: center;
	}

	.icon {
		padding-top: 3px;
	}

	.ivu-input {
		width: 400px;
		height: 40px;
		background: #F8F8F8;
		opacity: 1;
		border-radius: 4px;
	}
</style>
